export enum CRM_ACTIONS {
    LOGIN_SUCCESS = "CRM_ACTIONS_LOGIN_OK",
    CREATE_USER = "CRM_ACTIONS_CREATE_USER",
    CHANGE_PASSWORD = "CRM_ACTIONS_CHANGE_PASSWORD",
    GET_ABC_INSURANCE = "CRM_ACTIONS_GET_ABC_INSURANCE",
    LIST_COVERAGES = "CRM_ACTIONS_LIST_COVERAGES",
    LIST_CLINICS = "CRM_ACTIONS_LIST_CLINICS",
    LIST_GARAGES = "CRM_ACTIONS_LIST_GARAGES",
    GET_POLICY_DETAIL = "CRM_ACTIONS_GET_POLICY_DETAIL",
    LIST_INSURANCES = "CRM_ACTIONS_LIST_INSURANCES",
    DOWNLOAD_POLICY = "CRM_ACTIONS_DOWNLOAD_POLICY",
    LIST_CROSS_PAYMENT_COUPONS = "CRM_ACTIONS_LIST_CROSS_PAYMENT_COUPONS",
    LIST_PAYMENT_COUPONS = "CRM_ACTIONS_LIST_PAYMENT_COUPONS",
    GET_VOUCHER = "CRM_ACTIONS_GET_VOUCHER",
    GET_INSURANCE_ACTIVATION = "CRM_ACTIONS_GET_INSURANCE_ACTIVATION",
    DOWNLOAD_SOAT = "CRM_ACTIONS_DOWNLOAD_SOAT",
    DOWNLOAD_CERTIFICATE = "CRM_ACTIONS_DOWNLOAD_CERTIFICATE",
    DOWNLOAD_EECC = "CRM_ACTIONS_DOWNLOAD_EECC",
    DOWNLOAD_BULLET = "CRM_ACTIONS_DOWNLOAD_BULLET",
    GET_PK_TRACKING = "CRM_ACTIONS_GET_PK_TRACKING",
    UPDATE_INSURED_CONTACT_DATA = "CRM_ACTIONS_UPDATE_INSURED_CONTACT_DATA",
    DOWNLOAD_MULTIVENTAJA = "CRM_ACTIONS_DOWNLOAD_MULTIVENTAJA",
    GET_LIFE_BENEFITS = "CRM_ACTIONS_GET_LIFE_BENEFITS",
    GET_CAR_BENEFITS = "CRM_ACTIONS_GET_CAR_BENEFITS",
    CLAIM_DETAIL = "CRM_ACTIONS_CLAIM_DETAIL",
    DOWNLOAD_BALLOTS = "CRM_ACTIONS_DOWNLOAD_BALLOTS",
    CLAIM_REQUEST = "CRM_ACTIONS_CLAIM_REQUEST",
    GET_HEALTH_TRAVELER_CARNET_DETAIL = "CRM_ACTIONS_INFO_TRAVEL_CARD",
    DOWNLOAD_HEALTH_TRAVELER_CARNET = "CRM_ACTIONS_DOWNLOAD_TRAVEL_CARD",
    HOME_CLAIM_REQUEST = "CRM_ACTIONS_HOME_CLAIM_REQUEST",
    GET_VERA_WHATSAPP_CHAT = "CRM_ACTIONS_VERA_WHATSAPP_CHAT",
    PLAY_SCRATCH_GAME = "CRM_ACTIONS_PLAY_SCRATCH_GAME",
    TRACKING_DIGITAL_REQUEST = "CRM_ACTIONS_TRACKING_DIGITAL_REQUEST",
    MEDICINE_DELIVERY_REQUEST_TRACKING = "CRM_ACTIONS_MEDICINE_DELIVERY_REQUEST_TRACKING",
    GET_VEHICLE_FINES = "CRM_ACTIONS_GET_VEHICLE_FINES",
    GET_VACCINE_CARNET = "CRM_ACTIONS_GET_VACCINE_CARNET",
    VEHICULAR_ASSISTANCES_REQUEST_DOOR_OPENING = "CRM_ACTIONS_VEHICULAR_ASSISTANCES_REQUEST_DOOR_OPENING",
    VEHICULAR_ASSISTANCES_REQUEST_TIRE_CHANGE = "CRM_ACTIONS_VEHICULAR_ASSISTANCES_REQUEST_TIRE_CHANGE",
    VEHICULAR_ASSISTANCES_REQUEST_BATTERY_RECHARGE = "CRM_ACTIONS_VEHICULAR_ASSISTANCES_REQUEST_BATTERY_RECHARGE",
    VEHICULAR_ASSISTANCES_REQUEST_REPLACEMENT_DRIVER = "CRM_ACTIONS_VEHICULAR_ASSISTANCES_REQUEST_REPLACEMENT_DRIVER",
    VEHICULAR_ASSISTANCES_REQUEST_CRANE_REQUEST = "CRM_ACTIONS_VEHICULAR_ASSISTANCES_REQUEST_CRANE_REQUEST",
    VEHICULAR_ASSISTANCES_REQUEST_ALARM_DEACTIVATION = "CRM_ACTIONS_VEHICULAR_ASSISTANCES_REQUEST_ALARM_DEACTIVATION",
    ELECTIONS_OFFICER = "CRM_ACTIONS_CHECK_ELECTIONS_OFFICER",
    COVER_NOTE_REQUEST_TRACKING = "CRM_ACTIONS_COVER_NOTE_REQUEST_TRACKING",
    LOCATE_YOUR_STATION = "CRM_ACTIONS_LOCATE_YOUR_STATION",
    COCOS_Y_LUCAS = "CRM_ACTIONS_COCOS_Y_LUCAS",
    PODCAST_EARTHQUAKE = "CRM_ACTIONS_PODCAST_EARTHQUAKE",
    BENEFITS_VEHICLE = "CRM_ACTIONS_BENEFITS_VEHICLE",
    BENEFITS_RECONOCERTE = "CRM_ACTIONS_RECONOCERTE",
    HEALTH_REIMBURSEMENT_TRACKING_LISTING = "CRM_ACTIONS_HEALTH_REIMBURSEMENT_TRACKING_LISTING",
    HEALTH_REIMBURSEMENT_TRACKING_DOWNLOAD_REJECTION = "CRM_ACTIONS_HEALTH_REIMBURSEMENT_TRACKING_DOWNLOAD_REJECTION",
    HEALTH_REIMBURSEMENT_TRACKING_DOWNLOAD_LIQUIDATION = "CRM_ACTIONS_HEALTH_REIMBURSEMENT_TRACKING_DOWNLOAD_LIQUIDATION",
}
